<template>
	<div>
		<modalconfirm ref="modalApprovalPO" @action="proccessPO"/>
		<modalSchedule ref="modalSchedule" @saveSchedule="saveSchedule"/>
		<div class="text-h5">Approval Pemesanan</div>
		<v-card class="mt-3" outlined>
			<v-card-text class="pt-2">
				<v-alert v-for="(alert, index) in alertMultiple" v-model="alert.show" :key="index" dismissible type="error" elevation="1">
					{{alert.message}}
				</v-alert>
				<v-form>
					<v-row>
						<v-col cols="12" sm="4" md="4">
							<v-autocomplete item-value="po_code" @change="getDetail(po_code)" hide-details="auto" v-model="po_code" :items="OptionPO" label="Kode Pemesanan" outlined dense no-data-text="Belum ada data tersedia">
								<template v-slot:item = {item}>
									{{item.po_code}} - {{item.supplier_name}}
								</template>
								<template v-slot:selection = {item}>
									{{item.po_code}}
								</template>
							</v-autocomplete>
						</v-col>
						<v-col cols="12" class="pb-5" v-if="Object.keys(detailPO).length > 0">
							<div class="font-weight-bold">Detail Supplier</div>
							<v-row>
								<v-col cols="12" md="4">
									<div class="d-flex">
										<v-icon>mdi-warehouse</v-icon>
										<div class="pl-3">{{ detailPO.supplier_name }}</div>
									</div>
									<div class="d-flex pt-2">
										<v-icon>mdi-email</v-icon>
										<div class="pl-3">{{ detailPO.supplier_email }}</div>
									</div>
								</v-col>
								<v-col cols="12" md="8">
									<div class="d-flex">
										<v-icon>mdi-phone</v-icon>
										<div class="pl-3">{{ detailPO.supplier_mobilephone }}</div>
									</div>
									<div class="d-flex pt-2">
										<v-icon class="icon-align-top">mdi-map-marker</v-icon>
										<div class="pl-3">{{ addresText }}</div>
									</div>
								</v-col>
							</v-row>
							<div class="font-weight-bold">Catatan : {{ detailPO.po_note ? detailPO.po_note : '-' }}</div>
						</v-col>
						<v-col cols="12">
							<v-alert v-if="responseError.product" type="error" elevation="1">
								{{responseError.product}}
							</v-alert>
							<v-simple-table class="white-row">
								<template v-slot:default>
									<thead class="v-data-table-header">
										<tr>
											<th width="5%" class="text-left">Aksi</th>
											<th width="40%" class="text-left">Nama Produk</th>
											<th width="20%" class="text-left">Kode Produk</th>
											<th width="20%" class="text-left">Jumlah Permintaan</th>
											<th width="15%" class="text-left">Jumlah Approval</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="(product, index) in productPO" :key="product.po_detail_product_id">
											<td>
												<v-tooltip bottom>
													<template v-slot:activator="{ on, attrs }">
														<v-badge bordered color="error" :content="product.po_detail_schedule.length" :value="product.po_detail_schedule.length" overlap>
															<v-btn :disabled="product.quantity == 0" fab light x-small depressed :color="product.po_detail_schedule.length > 0 ? 'primary' : 'primary lighten-3'" v-bind="attrs" v-on="on" @click.stop="setSchedule(index, product.quantity, product.po_detail_schedule, product.po_detail_product_code)">
																<v-icon dark>mdi-calendar</v-icon>
															</v-btn>
														</v-badge>
													</template>
													<span>Atur Jadwal</span>
												</v-tooltip>
											</td>
											<td> {{ product.po_detail_product_name }} </td>
											<td> {{ product.po_detail_product_code }} </td>
											<td> {{ product.po_detail_quantity_requested | toNumber }} {{ product.po_detail_product_unit }}</td>
											<td>
												<v-currency-field v-model.lazy="product.quantity" label="Jumlah" :rules="[inputrules.required, inputrules.notnull]" :outlined="true" dense hide-details="auto" background-color="white" class="py-3 details-mb-0"/>
											</td>
										</tr>
									</tbody>
									<tfoot>
									</tfoot>
								</template>
							</v-simple-table>
						</v-col>
					</v-row>
				</v-form>
			</v-card-text>
			<v-card-actions class="px-4 pb-4 pt-5">
				<v-spacer></v-spacer>
				<v-btn color="grey darken-1" :disabled="!po_code" outlined class="text-capitalize" @click="reject">Tolak</v-btn>
				<v-btn color="primary darken-1" :disabled="!po_code" depressed class="text-capitalize" @click="approve">Proses</v-btn>
			</v-card-actions>
		</v-card>
	</div>
</template>

<script>

import {mapActions, mapState, mapMutations} from 'vuex'
import modalSchedule from '@/views/MLwarehouse/po/ModalSchedulePO'

export default {
	inject: ['theme'],
	components: {
		modalSchedule
	},
	data() {
		return {
			po_code: '',
			poProccess: '',
			headers: [
			{ text: 'Aksi', align: 'start', value: 'action', sortable: false},
			{ text: 'Nama Produk', align: 'start', value: 'product_name', sortable: true},
			{ text: 'Kode Produk', value: 'product_code', sortable: false},
			{ text: 'Jumlah Permintaan', value: 'po_detail_quantity_requested', align: 'center'},
			{ text: 'Jumlah Disetujui', value: 'quantity', width: '17%'},
			],
			productPO: [],
		}
	},
	props: {
	},
	computed: {
		...mapState('po', ['detailPO', 'response', 'responseError', 'OptionPO', 'alertMultiple']),

		addresText(){
			var data = []
			if (this.detailPO) {
				if (this.detailPO.supplier_address)
					data.push(this.detailPO.supplier_address)
				if (this.detailPO.supplier_subdistrict_name)
					data.push(this.detailPO.supplier_subdistrict_name)
				if (this.detailPO.supplier_city_name)
					data.push(this.detailPO.supplier_city_name)
				if (this.detailPO.supplier_province_name)
					data.push(this.detailPO.supplier_province_name)
			}
			return data.join(', ')
		}
	},
	methods: {
		...mapActions('po', ['getDetailPO', 'approvePO', 'rejectPO', 'getOptionPOforApprove']),
		...mapMutations('po', ['setDetailPO', 'clearDataPO', 'multipleAlert', 'saveResponse']),
		...mapMutations(['setOverlay']),

		getDetail(code) {
			if (code) {
				this.getDetailPO(code).then( () => {
					this.productPO = this.detailPO.po_detail.map((el, index) => {
						el.index = index
						el.quantity = el.po_detail_quantity_requested
						if (el.po_detail_schedule) {
							el.po_detail_schedule = el.po_detail_schedule.map((el) => {
								return {
									date: el.po_schedule_detail_date,
									quantity: el.po_schedule_detail_quantity
								}
							})
						}
						return el
					})
				})
			} else {
				this.setDetailPO({})
				this.productPO = []
			}
		},
		approve(){
			this.poProccess = 'approve'
			let msg = "Yakin akan memproses Pemesanan ini?"
			this.$refs.modalApprovalPO.setMessage(msg)
			this.$refs.modalApprovalPO.showConfirm()
		},
		reject(){
			this.poProccess = 'reject'
			let msg = "Yakin akan membatalkan Pemesanan ini?"
			this.$refs.modalApprovalPO.setMessage(msg)
			this.$refs.modalApprovalPO.showConfirm()
		},
		setSchedule(index, quantity, schedule, code){
			this.multipleAlert([])
			this.$refs.modalSchedule.showModal(index, quantity, schedule, code)
		},
		saveSchedule(data, index) {
			this.detailPO.po_detail[index].po_detail_schedule = [... data]
		},
		async proccessPO() {
			await this.setOverlay(true)
			await this.$refs.modalApprovalPO.hideConfirm()
			var product = await this.productPO.map( el => {
				return {
					product_id : el.po_detail_product_id,
					product_name : el.po_detail_product_name,
					quantity : el.quantity,
					schedule: el.po_detail_schedule
				}
			})
			let msg = await []
			await product.forEach( el => {
				let qty = el.quantity
				let totalQty = 0
				el.schedule.forEach( el => {
					totalQty += parseInt(el.quantity)
				});
				if (qty != totalQty && totalQty > 0) {
					msg.push(`Jumlah Produk ${el.product_name} dijadwalkan tidak cocok dengan jumlah diminta`);
				}
			})
			await this.multipleAlert(msg)
			if (msg.length == 0) {
				if (this.poProccess == 'approve') {
					await this.approvePO({
						supplier_id: this.detailPO.po_supplier_id,
						po_id : this.detailPO.po_id,
						product : product
					}).then(() => {
						if (this.response.code == 200.) {
							this.resetForm()
						}
					})
				} else if (this.poProccess == 'reject') {
					await this.rejectPO(this.detailPO.po_id).then(() => {
						if (this.response.code == 200.) {
							this.resetForm()
						}
					})
				}
			}
			await this.setOverlay(false)
		},
		resetForm() {
			this.saveResponse({})
			this.productPO = []
			this.getOptionPOforApprove()
			this.po_code = ''
			this.setDetailPO({})
		}
	},
	created() {
		this.$store.dispatch('setPageTitle', `Approval Pemesanan`)
		this.getOptionPOforApprove().then(() => {
			if (this.$route.params.code) {
				this.po_code = this.$route.params.code
				this.getDetail(this.$route.params.code)
			}
		})
	},
	beforeDestroy() {
		this.clearDataPO()
	},
	watch: {
	}
}
</script>